import React from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {ShowOnMobileOnly} from '@wix/wixstores-client-common-components/dist/es/src/HOC/responsive/ShowOnMobileOnly/ShowOnMobileOnly';
import {useGlobals} from '../../../providers/globalPropsProvider';
import {SPECS} from '../../../specs';
import {LayoutId, ProductPageSlotIds} from '../../../constants';
import {RibbonsGroupOnImage} from '../../ProductRibbons/ProductRibbons';
import {Mode, WishlistButton} from '../../ProductPageButtonsContainer/WishlistButton/WishlistButton';
import {ProductPageMediaSlot} from './ProductPageMediaSlot';
import styles from './MediaOverlay.scss';

export const MediaOverlayDataHook = {
  Root: 'product-page-media-overlay',
};

export interface MediaOverlayProps {
  shouldRenderMediaSlot?: boolean;
}

export const MediaOverlay: React.FC<MediaOverlayProps> = ({shouldRenderMediaSlot = true}) => {
  const {layoutId, slots, shouldShowWishlistButton} = useGlobals();

  const {experiments} = useExperiments();
  const ribbonsInProductPageEnabled = experiments.enabled(SPECS.ShowMultiRibbonsInProductPage);
  const renderProductPageSlots = experiments.enabled(SPECS.PRODUCT_PAGE_SLOTS);
  if (!ribbonsInProductPageEnabled) {
    return null;
  }

  const isMediaPluginInstalled = !!slots?.[ProductPageSlotIds.ProductPageMedia1];
  const isStunning = layoutId === LayoutId.Stunning;
  const shouldRenderSlot = shouldRenderMediaSlot && renderProductPageSlots;

  return (
    <div className={styles.mediaOverlayRoot} data-hook={MediaOverlayDataHook.Root}>
      <div className={styles.mediaOverlayRibbonsAndSlotContainer}>
        <RibbonsGroupOnImage />
        {shouldRenderSlot && (
          <ProductPageMediaSlot isMediaPluginInstalled={isMediaPluginInstalled} isStunning={isStunning} />
        )}
      </div>
      {shouldShowWishlistButton && (
        <ShowOnMobileOnly>
          <WishlistButton mode={Mode.FLOATING} />
        </ShowOnMobileOnly>
      )}
    </div>
  );
};
